import classNames from 'classnames';
import Image from 'next/image';

import { ArrRight } from '@/icons/index';

import SectionTitle from '../SectionTitle/SectionTitle';

import styles from './PaymentCards.module.scss';

const PaymentCards = ({ data, className }) => {
  const renderPaymentCard = (item, index) => {
    return (
      <a
        className={styles['payments-card']}
        href={item?.link}
        key={index}
        target={'_blank'}
        rel='noopener noreferrer'
        itemScope
        itemType='https://schema.org/PaymentCard'
      >
        {item?.logo && (
          <div className={styles['payments-card__logo-wrap']}>
            <Image
              className={styles['payments-card__logo']}
              src={item.logo}
              alt={item?.title}
              title={item?.title}
              loading='lazy'
              width={160}
              height={64}
              layout='responsive'
              objectFit='contain'
            />
          </div>
        )}
        {item?.title && (
          <div className={styles['payments-card__content']}>
            <SectionTitle
              titleModify={classNames(
                styles['payments-card__title'],
                'title--medium',
              )}
            >
              {item?.title}
            </SectionTitle>
            <ArrRight className={styles['payments-card__icon']} />
          </div>
        )}
      </a>
    );
  };

  return (
    <section
      className={classNames(styles['payments-cards'], className)}
      itemScope
      itemType='https://schema.org/PaymentCard'
    >
      {data?.title && (
        <SectionTitle
          className={classNames(
            styles['payments-cards__title'],
            'title--large',
          )}
          icon={data?.icon}
        >
          {data?.title}
        </SectionTitle>
      )}
      {data?.cards && (
        <div className={styles['payments-cards__inner']}>
          {data.cards.map(renderPaymentCard)}
        </div>
      )}
    </section>
  );
};

export default PaymentCards;
